class zone {
  constructor(data) {
    const MEDICAL_LIMITS = {
      Elite: "$150,000",
      Plantinum: "$100,000",
      Gold: "$50,000",
      Silver: "$25,000",
      Standard: "$10,000",
    };

    const PA_LIMITS = {
      Elite: "$30,000",
      Plantinum: "$25,000",
      Gold: "$20,000",
      Silver: "$10,000",
      Standard: "$5,000",
    };
    const medicalLimit = MEDICAL_LIMITS[data.text];
    const paLimit = PA_LIMITS[data.text];

    this.items = {
      id: 30001,
      name: "Zone",
      type: "text",
      slideimg: "/doctorassistant/dia.jpg",
      options: [
        {
          id: 40012,
          text: "Zone 1 — Worldwide incl USA/Canada/Australia",
          name: "Zone 1 — Worldwide incl USA/Canada/Australia",
          type: "coverageType",
          desc: "Zone 1 — Worldwide incl USA/Canada/Australia",
          inputtype: "button",
          key: "zone",
          value: 0,
        },
        {
          id: 40012,
          text: "Zone 2 — Worldwide excl USA/Canada/Australia",
          name: "Zone 2 — Worldwide excl USA/Canada/Australia",
          type: "coverageType",
          desc: "Zone 2 — Worldwide excl USA/Canada/Australia",
          inputtype: "button",
          key: "zone",
          value: 1,
        },
        {
          id: 40012,
          text: "Zone 3 — Europe",
          name: "Zone 3 — Europe",
          type: "coverageType",
          desc: "Zone 3 — Europe",
          inputtype: "button",
          key: "zone",
          value: 2,
        },
      ],
      backtostart: false,
      text: [
        `<p>
    Excellent choice! Your plan provides comprehensive travel protection, including 
    <ul> 
    <li>Medical Coverage up to <strong>${medicalLimit}</strong> </li> 
    <li>Personal Accident Coverage up to <strong>${paLimit}</strong></li>
    </ul>
    This ensures you are financially protected in case of medical emergencies or 
    unexpected accidents during your trip.
    </p>`,
        `<p>Now Please select the travel coverage zone based on the countries you plan to visit. Your insurance coverage will apply only within the selected zone.</p> `,
      ],
    };
  }

  getAllItems() {
    return this.items;
  }
}

export default zone;
